import _environmentV8Version from "../internals/environment-v8-version";
import _fails from "../internals/fails";
import _globalThis2 from "../internals/global-this";
var exports = {};
/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = _environmentV8Version;
var fails = _fails;
var _globalThis = _globalThis2;
var $String = _globalThis.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol("symbol detection");
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});
export default exports;